import userRequest from '@/utils/request'

// home
export function getJsonCompanyNumAndCategoryData (data) {
  return userRequest({
    url: '/getJsonCompanyNumAndCategoryData',
    method: 'POST',
    data: data
  })
}

// question

export function getJsonQuestAndOptData (data) {
  return userRequest({
    url: '/getJsonQuestAndOptData',
    method: 'POST',
    data: data
  })
}

export function sendCompanyData (data) {
  return userRequest({
    url: '/sendCompanyData',
    method: 'POST',
    data: data
  })
}

// contact us
export function getComputeAnalyzeMain (data) {
  return userRequest({
    url: '/getComputeAnalyzeMain',
    method: 'POST',
    data: data
  })
}

export function getEmailCheckVerCode (data) {
  return userRequest({
    url: '/getEmailCheckVerCode',
    method: 'POST',
    data: data
  })
}

// result

export function getAnalyzeAndOpt (data) {
  return userRequest({
    url: '/getAnalyzeAndOpt',
    method: 'POST',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/API/analyze.js